/* eslint react/forbid-prop-types:0 */
/* eslint no-underscore-dangle:0 */

import React from "react";
import PropTypes from "prop-types";
import BusStopResult from "./BusStopResult";
import { flattenRoutes } from "../../util/tools";

const BusStopResults = ({ Results, PlatformNo }) => {
  let Title = "";
  let Routes = [];
  let SortedRoutes = [];

  if (Object.keys(Results).length > 0) {
    Title = Results._attributes.Name;
    Routes = Results.Route;
    // Order by ETA
    SortedRoutes = flattenRoutes(Routes).sort(
      (route1, route2) => route1.ETA - route2.ETA
    );
  }

  return (
    <div>
      {typeof Routes === "object" ? (
        <div>
          <p className="next-bus__text">
            Stop &quot;{PlatformNo}&quot; - {Title}
          </p>
          <div className="table next-bus__list">
            <div className="table__header">
              <div className="table__item table__item--route">Route</div>
              <div className="table__item table__item--destination">
                Destination
              </div>
              <div className="table__item table__item--due">Due</div>
            </div>
            {SortedRoutes.map(route => (
              <BusStopResult
                key={route.ID}
                RouteNo={route.RouteNo}
                RouteName={route.RouteName}
                DestinationName={route.Name}
                Due={route.ETA}
              />
            ))}
          </div>
        </div>
      ) : (
        <div>
          No stops match this number. Please try searching with a different
          number, or with a street name
        </div>
      )}
    </div>
  );
};

BusStopResults.defaultProps = {
  Results: {},
  PlatformNo: null
};

BusStopResults.propTypes = {
  Results: PropTypes.object,
  PlatformNo: PropTypes.number
};

export default BusStopResults;
